export const PROJECT_USERS_FETCHED = 'projectUsersFetched';
export const USER_DATA_FETCHED = 'userDataFetched';
export const COMMENT_REMOVED = 'commentRemoved'; // Deleted
export const COMMENT_STATUS_CHANGED = 'commentStatusChanged';

export const WYSIWYG_EDITOR_IFRAME_SCROLL = 'wysiwygEditorIframeScroll';
export const WYSIWYG_EDITOR_IFRAME_CLICK = 'wysiwygEditorIframeClick';
export const WYSIWYG_EDITOR_MODE = 'wysiwygEditorMode';
export const MAIN_WINDOW_CLICK = 'mainWindowClick';
export const COMMENT_UPDATED = 'commentUpdated';
export const COMMENT_CARD_CLICK = 'commentCardClick';
export const COMMENT_SELECTION_CLICK = 'commentSelectionClick';
export const COMMENTED_FILE_CLICK = 'commentedFileClick';
export const COMMENT_GROUP_CLICK = 'commentGroupClick';
export const COMMENTS_RESOLVED_TOGGLED = 'commentsResolvedToggled';

export const SELECTED_TEXT_REMOVED = 'selectedTextRemoved';
export const SELECTED_TEXT_MODIFIED = 'selectedTextModified';

export const CONNECTION_ESTABLISHED = 'connectionEstablished'
export const CONNECTION_ABORTED = 'connectionAborted'
export const CURRENT_USER_CONNECTION = 'currentUserConnection'
export const USER_INPUT_STARTED = 'userInputStarted'
export const USER_INPUT_STOPPED = 'userInputStopped'

export const WIDGET_SCROLL_COMPLETE = 'widgetScrollComplete';
export const WIDGET_VALUE_RECEIVED = 'widgetValueReceived'
export const ASSIGNMENT_DATA_FETCHED = 'assignmentDataFetched'
export const CHANGE_ASSIGNMENT_STATUS_EVENT = 'changeAssignmentStatusEvent'
export const APPROVE_ASSIGMENT_EVENT = 'approveAssignmentEvent'
export const REJECT_ARTICLE_EVENT = 'rejectArticleEvent'

export const AFTER_GUEST_REGISTERED = 'afterGuestRegistered'
export const AFTER_USER_LOGIN = 'afterUserLogin'
export const AFTER_LOG_OUT = 'afterLogOut'

export const ACTIVE_VERSION = 'activeVersion'
export const RESTORE_VERSION = 'restoreVersion'
export const RESTORE_VERSION_MODAL_CLOSED = 'restoreVersionModalClosed'

export const MAIN_WINDOW_MOUSEMOVE = 'mainWindowMousemove';
export const MAIN_WINDOW_MOUSEUP = 'mainWindowMouseup';
export const MAIN_WINDOW_SCROLL = 'mainWindowScroll';
export const MAIN_WINDOW_RESIZE = 'mainWindowResize';
export const SCROLL = 'scroll';
export const WHEEL = 'wheel';
export const SCROLL_HEIGHT_CHANGED = 'scrollHeightChanged';
export const SIDEBAR_RESIZE = 'sidebarResize';
export const SIDEBAR_VISIBILITY = 'sidebarVisibility';

export const THEME_CHANGE_MENU_COLOR = 'themeChangeMenuColor';
export const THEME_CHANGE_LOGO_URL = 'themeChangeLogoUrl';

export const SHOW_DELETE_MODAL = 'showDeleteModal';

export const NAVBAR_MOUNTED = 'navbarMounted';

export const RTC_CONNECTION_STATE_CHANGED = 'rtcConnectionStateChanged';
export const BEFORE_WIDGETS_VALUES_INITIALIZATION = 'beforeWidgetsValuesInitialization';

export const PROGRESS_IMAGE_UPLOAD = 'progressImageUpload';

export const CLICK_FULLSCREEN_IMAGE = 'clickFullscreenImage';

export const FULLSCREEN_EDIT_TRANSITION_END = 'fullscreenEditTransitionEnd';

export const TEMPLATE_CHANGED = 'templateChanged';

function Bus() {
	let handlers = {};
	let history = {};

	this.on = (eventName, handler) => {
		initEventHandlersList(eventName);

		handlers[eventName].push({
			handler,
			once: false
		});
	};

	this.once = (eventName, handler) => {
		initEventHandlersList(eventName);

		handlers[eventName].push({
			handler,
			once: true
		});
	};

	this.off = (eventName, handler) => {
		if (!handlers[eventName]) {
			return;
		}

		const i = handlers[eventName].findIndex(h => h?.handler ? h.handler === handler : false);

		if (-1 === i) {
			return;
		}

		delete handlers[eventName][i];
	};

	this.emit = (eventName, payload) => {
		addHistoryRecord(eventName, payload);

		if (!handlers[eventName] || !handlers[eventName].length) {
			return;
		}

		handlers[eventName].forEach((o, i) => {
			if (undefined === payload) {
				o.handler();
			} else {
				o.handler(payload);
			}

			if (o.once) {
				delete handlers[eventName][i];
			}
		});
	};

	this.was = eventName => !!history[eventName];

	function addHistoryRecord(eventName, payload) {
		if (!history[eventName]) {
			history[eventName] = [];
		}

		history[eventName].push(payload);
	}

	function initEventHandlersList(eventName) {
		if (!handlers[eventName]) {
			handlers[eventName] = [];
		}
	}
}

export default new Bus();
